var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilderSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.861,
    height: 66.726,
    viewBox: "0 0 69.861 66.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2687",
    transform: "translate(-1144.418 -132.667)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2330",
    d: "M32.4,15C21.921,15,1,20.26,1,30.7v3.925A3.937,3.937,0,0,0,4.925,38.55H59.876A3.937,3.937,0,0,0,63.8,34.625V30.7C63.8,20.26,42.88,15,32.4,15Z",
    transform: "translate(1143.418 160.843)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2331",
    d: "M6.173,23.625H39.654A1.926,1.926,0,0,0,41.577,21.7v-.079A1.926,1.926,0,0,0,39.654,19.7h-1.06a15.688,15.688,0,0,0-7.85-13.541V9.888a1.963,1.963,0,0,1-3.925,0V4.55A16.056,16.056,0,0,0,22.894,4a16.056,16.056,0,0,0-3.925.55V9.888a1.963,1.963,0,0,1-3.925,0V6.159A15.688,15.688,0,0,0,7.194,19.7H6.173A1.926,1.926,0,0,0,4.25,21.623v.118A1.919,1.919,0,0,0,6.173,23.625Z",
    transform: "translate(1152.925 128.667)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2332",
    d: "M20.291,21.775A15.7,15.7,0,0,0,35.441,10H5.14A15.7,15.7,0,0,0,20.291,21.775Z",
    transform: "translate(1155.529 146.215)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    "data-name": "Pfad 2333",
    d: "M35.057,13.4l2.995-2.673L35.636,6.542,31.8,7.8a6.384,6.384,0,0,0-1.513-.869L29.486,3h-4.83l-.805,3.929A7.315,7.315,0,0,0,22.3,7.8l-3.8-1.256L16.09,10.728,19.085,13.4a7.28,7.28,0,0,0,0,1.674L16.09,17.813,18.505,22l3.864-1.224a7.4,7.4,0,0,0,1.385.805l.9,3.961h4.83l.869-3.929a7.665,7.665,0,0,0,1.417-.805L35.6,22.031l2.415-4.186-2.995-2.737A7.631,7.631,0,0,0,35.057,13.4ZM27.071,18.3A4.025,4.025,0,1,1,31.1,14.271,4.027,4.027,0,0,1,27.071,18.3Z",
    transform: "translate(1164.27 169.958)",
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    "data-name": "Pfad 2334",
    d: "M30.5,12.756l-3.029.977A4.838,4.838,0,0,0,26.3,13.07L25.655,10H21.841L21.2,13.036a6.68,6.68,0,0,0-1.212.663l-2.994-.977L15.07,15.966l2.352,2.059a7.8,7.8,0,0,0,0,1.291L15.07,21.444l1.924,3.245,3.065-.942a6.892,6.892,0,0,0,1.1.628l.641,3.07h3.813L26.3,24.41a7.229,7.229,0,0,0,1.14-.628l3.029.942,1.925-3.245-2.352-2.128a7.8,7.8,0,0,0,0-1.291L32.391,16Z",
    transform: "translate(1180.609 151.196)",
    fill: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fill-background",
    "data-name": "Ellipse 288",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1202 167.394)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderSettingsIcon);
export default __webpack_public_path__ + "static/media/builderSettingsIcon.100faa0e.svg";
export { ForwardRef as ReactComponent };